import firestoreServices from '../services/firestore.service';

const usersFirestoreServices = firestoreServices('roles');

const listElements = queryResult => {
  let elements = [];
  queryResult.forEach((doc, _) => {
    elements.push({ id: doc.id, ...doc.data() });
  });
  return elements;
};

export default {
  ...usersFirestoreServices,
  where: (fieldPath, opStr, value, onResult) =>
    usersFirestoreServices
      .collectionRef()
      .where(fieldPath, opStr, value)
      .get()
      .then(async queryResult => onResult(await listElements(queryResult)))
};
